{
  "planReady": {
    "title": "Votre plan est prêt",
    "body": "{{name}} — relisez le plan généré."
  },
  "dataIngestComplete": {
    "title": "Vos fichiers sont prêts",
    "body": "{{name}} — {{count}} fichiers traités."
  },
  "completenessReady": {
    "title": "Vérification des données terminée",
    "body": "{{name}} — vous pouvez lancer la génération."
  },
  "completenessNeedsData": {
    "title": "Vérification des données terminée",
    "body": "{{name}} — des données manquent. Vérifiez ce qui est requis."
  },
  "sectionsReady": {
    "title": "Vos sections sont prêtes",
    "body": "{{name}} — {{count}} sections générées. Prêtes à relire."
  },
  "validationComplete": {
    "title": "Auto-vérification terminée",
    "body": "{{name}} — relisez le rapport auto-vérifié."
  },
  "planRevisionComplete": {
    "title": "Plan mis à jour",
    "body": "{{name}} — relisez le plan révisé."
  },
  "failure": {
    "title": "Une action est requise",
    "body": "{{name}} — {{stage}} n'a pas pu se terminer. Ouvrez Bennie pour réessayer."
  },
  "stageNames": {
    "planGeneration": "La génération du plan",
    "dataIngest": "L'ingestion des données",
    "completenessCheck": "La vérification d'exhaustivité",
    "sectionGeneration": "La génération des sections",
    "validation": "L'auto-vérification",
    "planRevision": "La révision du plan"
  },
  "extractorComplete": {
    "title": "Extraction terminée",
    "body": "{{target}} — l'extrait du modèle est prêt."
  },
  "extractorFailed": {
    "title": "L'extraction n'a pas pu se terminer",
    "body": "{{target}} — ouvrez Bennie pour voir ce qui s'est passé."
  },
  "gatekeeperComplete": {
    "title": "Contrôle d'admission terminé",
    "body": "{{target}} — le verdict est rendu."
  },
  "gatekeeperFailed": {
    "title": "Le contrôle d'admission n'a pas pu se terminer",
    "body": "{{target}} — ouvrez Bennie pour voir ce qui s'est passé."
  }
}
